<template>
  <div class="container-chinese-card">
    <CRow alignHorizontal="end" alignVertical="center">
      <div
        class="containerIconClose"
        @click="funcRoute(content.navigate.close.action)"
      >
        <font-awesome-icon icon="times" class="IconClose" />
      </div>
    </CRow>
    <CCard class="customCard">
      <CCardHeader class="customCardHeaderActive">
        <CRow
          alignHorizontal="between"
          alignVertical="center"
          class="mr-2 ml-2"
        >
          <h3 :class="checkLangClass() + ' ' + 'm-2'">
            {{ checkLanguage(content.title) }} :
            {{ checkLanguage(content.description) }}
          </h3>
        </CRow>
      </CCardHeader>
      <CCardBody class="mb-3">
        <template v-if="content.content.item[0].button.action !== null">
          <ChatAudio :content="chatDisplay" :checkWidth="checkWidth" />
        </template>
        <template v-else>
          <Chat :content="chatDisplay" :checkWidth="checkWidth" />
        </template>
        <CRow alignVertical="center" alignHorizontal="center">
          <CButton
            color="danger"
            shape="pill"
            size="lg"
            class="ml-2 mr-2 mt-5 pl-4 pr-4 pt-2 pb-2"
            @click="funcBackRoute(content.navigate.previous.action)"
            >{{ checkLanguage(content.navigate.previous.title) }}</CButton
          >
          <CButton
            color="success"
            shape="pill"
            size="lg"
            class="ml-2 mr-2 mt-5 pl-4 pr-4 pt-2 pb-2"
            @click="nextConver(content.navigate.next.action)"
            >{{ checkLanguage(content.navigate.next.title) }}</CButton
          >
        </CRow>
      </CCardBody>
    </CCard>

    <PopupIntroCModal
      :code="content.navigate.next.action"
      :isAddQueueShow="modal.LKT01"
      :checkWidth="checkWidth"
      :checkAnswer="checkAnswer"
    />
  </div>
</template>
<script>
import Chat from '../../../../components/template/Chinese1/Chat.vue';
import ChatAudio from '../../../../components/template/Chinese1/ChatAudio.vue';
import {mapGetters} from 'vuex';
import PopupIntroCModal from '../../../../components/template/Chinese1/PopupIntroCModal.vue';
import '../../../../assets/scss/_chineseIcon.scss';
import '../../../../assets/scss/_chineseStyle.scss';

export default {
  components: {
    Chat,
    ChatAudio,
    PopupIntroCModal,
  },
  name: 'CardConver',
  props: {
    content: Object,
    checkWidth: String,
    // ConverType: String
  },
  data() {
    return {
      chatDisplay: [],
      lang: '',
      modal: {
        LKT01: false,
      },
      checkAnswer: true,
    };
  },

  computed: {
    ...mapGetters({
      storeLanguage: 'language/getLanguage',
    }),
  },

  watch: {
    storeLanguage: function (val) {
      this.lang = val;
    },
    content: function (val) {
      this.nextConver();
    },
  },

  mounted() {},

  created() {
    (this.lang = this.$store.getters['language/getLanguage']),
      this.nextConver();
  },

  beforeDestroy() {},

  methods: {
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    checkLanguage(val) {
      //?????? revised ?
      if (val) {
        for (let i = 0; i <= val.length; i++) {
          if (val[i]?.key == this.lang) {
            return val[i].value;
          }
        }
      } else {
        console.log('change language is error!!');
      }
    },
    nextConver(tempId) {
      if (this.chatDisplay.length < this.content.content.item.length) {
        this.chatDisplay.push(
          this.content.content.item[this.chatDisplay.length]
        );
      } else {
        this.$emit('nextRoute', tempId);
      }
    },
    funcBackRoute(tempId) {
      const path = tempId.split('-');
      // let body = '/' + str[0] + '/' + str[1];
      // this.$store.commit('necessary/setCodePage', str[1]);
      // this.$router.push(body);
      const previousPath = `/v3/${path[0]}/${path[1]}`;

      this.$router.push(previousPath);
    },
    funcRoute(tempId) {
      this.$emit('nextRoute', tempId);
    },
    playSound(sound) {
      if (sound) {
        var audio = new Audio(sound);
        audio.play();
      }
    },
  },
};
</script>
<style></style>
